
export default {
  name: 'OrderListItemWrapper',
  props: {
    iconClass: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconStyle() {
      if (!this.icon) return ''

      return `background-image: url(${this.icon});`
    },
  },
}
